export default __webpack_public_path__ + "static/negative_forest-b99828f18dd9373ba6e2fb27232298a1.png";